import { render } from "./deals-active.vue?vue&type=template&id=33cf2073"
import script from "./deals-active.vue?vue&type=script&lang=js"
export * from "./deals-active.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__